import React from 'react';
import Page from 'Shared/components/page/page';
import Description from 'Shared/components/description';
import { useTranslation } from 'Shared/util/custom-hooks';
import SalesMethods from './sales-methods';
import styles from './sales-methods-page.css';


const SalesMethodsPage = () => {
  const t = useTranslation(x => x.sales_methods);
  const tdb = useTranslation(x => x.dbTranslations);

  return (
    <Page
      narrowWidth
      title={{
        text: t.how_to_send_invoices,
        reducedMarginBottom: true,
      }}
    >
      <Description
        text={tdb.emptyStateYouCanSellYourInvoicesToUsEitherBy}
        className={styles.introductionContainer}
      />
      <SalesMethods />
    </Page>
  );
};

export default SalesMethodsPage;
